import styled from 'styled-components';

export const SideSelectorStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    background: rgba(129, 146, 228, 0.1);
    border-radius: 16px;
    padding: 4px;
    gap: 4px;
    cursor: default;
    color: rgba(255, 255, 255, 0.6);

    > * {
        flex: 1;
        padding: 8px 0;

        text-align: center;
        font-weight: 600;
        line-height: 24px;
    }

    > *:hover,
    .selected {
        background: rgba(129, 146, 228, 0.2);
        border-radius: 12px;
        color: #FFFFFF;
    }
`;